<template>
  <v-layout class="px-0 wrap card-connect-form" id="payment-form">
    <v-text-field
      class="flex xs12"
      id="name_on_card"
      label="Name On Card"
      v-model="name_on_card"
      placeholder="Please Enter"
      :error-messages="errors($v.name_on_card)"
      @blur="$v.name_on_card.$touch()"
      @focus="emitReset"
    ></v-text-field>
    <v-layout class="wrap-on-xs">
      <div class="d-flex flex-grow-1">
        <div class="iframe-wrap custom-mr">
          <iframe
            style="width: 100%; height: 41px;"
            id="tokenFrame"
            name="tokenFrame"
            :src="`https://fts.cardconnect.com/itoke/ajax-tokenizer.html?${options()}&css=${css()}`"
            frameborder="0"
            scrolling="no"
            @focus='inputActive = !inputActive'
            @blur='inputActive = !inputActive'
          ></iframe>
        </div>
      </div>
      <div class="d-flex flex-shrink-1">
        <div style="min-width: 136px;">
          <select
            v-model="expiry_month"
            class="card-connect-input custom-mr"
            :class="{'input-error': errors($v.expiry_month)}"
            style="width: 41px;"
            :style="expiry_month === '' ? 'color:gray;': ''"
            @blur="$v.expiry_month.$touch()"
            @change="$v.expiry_month.$touch()"
          >
            <option value="" selected style="color:gray;">MM</option>
            <option
              v-for="month in monthOptions"
              :key="month" :value="month"
              style="color:rgba(0, 0, 0, 0.87);"
            >
              {{ `${Number(month) > 9 ? '' : '0'}${month}` }}
            </option>
          </select>
          <select
            v-model="expiry_year"
            class="card-connect-input custom-mr"
            :class="{'input-error': errors($v.expiry_year)}"
            style="width: 50.5px;"
            :style="expiry_year === '' ? 'color:gray;': ''"
            @blur="$v.expiry_year.$touch()"
            @change="$v.expiry_year.$touch()"
          >
            <option value="" selected style="color:gray;">YYYY</option>
            <option
              v-for="year in yearOptions"
              :key="year"
              :value="year"
              style="color:rgba(0, 0, 0, 0.87);"
            >
              {{ year }}
            </option>
          </select>
          <input
            class="card-connect-input"
            :class="{'input-error': errors($v.cvv)}"
            label="CVV"
            placeholder="CVV"
            style="width: 40px;"
            v-model="cvv"
            v-mask="'####'"
            @blur="$v.cvv.$touch()"
          />
        </div>
      </div>
    </v-layout>
    <div class="flex xs12 caption error--text" id="card-errors" v-text="cardErrorMessage()"></div>
    <v-text-field
      class="flex xs12 mt-4"
      id="postal_on_card"
      label="Billing Zip Code"
      v-model="postal"
      placeholder="Please Enter"
      v-mask="'#####'"
      :error-messages="errors($v.postal)"
      @blur="$v.postal.$touch()"
      @focus="emitReset"
    ></v-text-field>
    <p class="note mt-4">*Enter Credit Card to Be Used for Payments.</p>
  </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import { valMessages, getValMessage } from '@/common/error-messages'
import { mask } from 'vue-the-mask'

let validations = {}

export default {
  name: 'CardConnectForm',
  props: ['formBus'],
  mixins: [validationMixin],
  validations,
  directives: {mask},
  validations() {
    validations = {
      name_on_card: { required },
      postal: { 
        required,
        zipCode: v => !helpers.req(v) || /^\d{5}$/.test(v)
      },
      cc_token: { cardNumberRequired: required },
      cardNumberValidationError: {
        cardNumberRequired: v => v === ''
      },
      expiry_month: {
        expiryMonthRequired: required,
        cardExpiry: v => 
          !helpers.req(v) ||
          this.no_data.includes(this.expiry_month) ||
          this.no_data.includes(this.expiry_year) ||
          moment(`${this.expiry_year}-${Number(v) > 9 ? '' : '0'}${v}-01`, 'YYYY-MM-DD', true).isSameOrAfter(moment().startOf('month')),
      },
      expiry_year: {
        expiryYearRequired: required,
        cardExpiry: v => 
          !helpers.req(v) ||
          this.no_data.includes(this.expiry_month) ||
          this.no_data.includes(this.expiry_year) ||
          moment(`${v}-${Number(this.expiry_month) > 9 ? '' : '0'}${this.expiry_month}-01`, 'YYYY-MM-DD', true).isSameOrAfter(moment().startOf('month')),
      },
      cvv: { 
        cvvRequired: required, 
        cvv: v => !helpers.req(v) || /^\d{3}$/.test(v) || /^\d{4}$/.test(v) 
      }
    };
    this.errors = getValMessage(valMessages)(validations);
    return validations;
  },
  data () {
    return {
      no_data: [null, '', undefined, 'null'],
      inputActive: false,
      cc_token: null,
      expiry: null,
      expiry_month: '',
      expiry_year: '',
      cvv: null,
      name_on_card: null,
      postal: null,
      cardNumberValidationError: "",
      monthOptions: this.setMonthOptions(),
      yearOptions: this.setYearOptions()
    }
  },
  created() {
    window.addEventListener('message', this.onIframeEvent, false);
    this.$watch('$v.$error', () => {
      this.emitState();
    })
  },
  mounted() {
    this.formBus.$on('gaveMeToken', this.pay)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.onIframeEvent, false)
    this.formBus.$off('gaveMeToken', this.pay)
  },
  methods: {
    onIframeEvent (event) {
      if(event.origin === 'https://fts.cardconnect.com') {
        var token = JSON.parse(event.data);
        this.cc_token = token.message;
        this.cardNumberValidationError = token.validationError || token.errorMessage || "";
        if (token && token.errorCode && token.errorCode !== '00' && this.cardNumberValidationError === "") {
          this.cardNumberValidationError = `Error Code: ${token.errorCode}`
        }
      }
    },
    pay() {
      this.$v.$touch()
      this.emitState()
      if(!this.$v.$invalid) 
        {
          this.$emit('token', {
            cc_token: this.cc_token,
            expiry: `${
              Number(this.expiry_month) > 9 ? '' : '0'}${this.expiry_month}${
              String(this.expiry_year).slice(-2)}`,
            name_on_card: this.name_on_card,
            postal: this.postal,
            cvv: this.cvv
          })
        }
    },
    emitState() {
      let data = { 
        cardErrorMessage: this.cardErrorMessage(), 
        nameErrorMessage: this.errors(this.$v.name_on_card) ? this.errors(this.$v.name_on_card) : '',
        postalErrorMessage: this.errors(this.$v.postal) ? this.errors(this.$v.postal) : '',
        complete: !this.$v.$invalid
      }
      this.$emit('state', data)
      this.emitReset()
    },
    emitReset() {
      this.$emit('resetServer')
    },
    cardErrorMessage () {
      if(this.cardNumberValidationError) { return this.cardNumberValidationError }
      if(this.errors(this.$v.cc_token)) { return this.errors(this.$v.cc_token) }
      if(this.errors(this.$v.expiry_month)) { return this.errors(this.$v.expiry_month) }
      if(this.errors(this.$v.expiry_year)) { return this.errors(this.$v.expiry_year) }
      if(this.errors(this.$v.cvv)) { return this.errors(this.$v.cvv) }
      return ""
    },
    errors: getValMessage(valMessages)(validations),
    options () {
      const options = {
        // useexpiry: true,
        // usecvv: true,
        // invalidcreditcardevent: true,
        invalidinputevent: true,
        // autofocus: true,
        // invalidcvvevent: true,
        // invalidexpiryevent: true,
        cardinputmaxlength: '19',
        formatinput: true,
        cardnumbernumericonly: true,
        placeholder: 'Card number',
        // placeholdermonth: 'MM',
        // placeholderyear: 'YYYY',
        // placeholdercvv: 'CVV',
        orientation: 'horizontal',
      }
      return Object.entries(options).map(i => `${i[0]}=${i[1]}`).join('&')
    },
    css () {
      let css = ''
      css += 'body{margin:0;}'
      css += '.error{color:rgb(255,82,82);}'
      css += 'br{display:none;}'
      css += 'label{display:none;}'
      css += 'input{ box-sizing: border-box; color: rgba(0, 0, 0, 0.87); font-size:15px; border-radius: 4px; border: 1px solid; border-color: grey; width: 100%; margin-top:5px; line-height: 2.1}'
      css += 'input.error{color:rgb(255,82,82);border-color: rgb(255,82,82);}'
      css += 'input:focus{outline:none; border: 1px solid; border-color: rgb(0,172,193);}'
      css += 'input.error:focus{outline:none; border: 1px solid; border-color: rgb(255,82,82);}'
      return encodeURI(css)
    },
    setMonthOptions () {
      let output = []
      for (let i = 1; i <= 12; i++) { output.push(i) }
      return output
    },
    setYearOptions () {
      let output = []
      for (
        let i = Number(moment().format('YYYY'));
        i <= Number(moment().format('YYYY')) + 19;
        i++
      ) { output.push(i) }
      return output
    }
  }
}
</script>

<style scoped>
.container.grid-list-md .layout:not(:only-child) {
    margin: auto 0px;
}
.note{
    padding: 10px 0px;
    font-size: 12px;
    color: gray;
    font-style: italic;
}
.v-card .grid-list-md {
    max-width: 450px;
    padding-top: 50px;
    padding-bottom: 50px;
    padding-left: 0;
    padding-right: 0;
}
.spacer{
    display: block;
    width: 100%;
}
.theme--light .toolbar {
    background-color: #3AB0CE;
    color: rgb(255, 255, 255);
}
.v-card__text.zip-form {
    padding: 35px;
    width: 100%;
    max-width: 540px;
    margin: 0px auto;
}
.img-wrap {
    padding: 25px 0px!important;
    text-align: right;
}
.v-card{
    box-shadow: none;
}
.terms{
    margin-top: 0px;
}
.terms .accent--text{
    color: #3ab0cf !important;
}
.sub-button{
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    color:white!important;
    flex: 1;
    margin: 6px 0;
    background-color: #3ab0cf!important;
    width: 100%;
    text-align: center;
    padding:15px!important;
    font-weight: 300;
    font-size: 16px;
    margin-top: 20px;
    height: auto;
}
.sub-button .btn__content{
    padding:9px;
}
.application .theme--light.btn:not(.btn--icon):not(.btn--flat),
.theme--light .btn:not(.btn--icon):not(.btn--flat) {
    background-color: #3ab0ce;
    color: white;
    padding: 0;
}
.form-control:focus {
    color: #495057;
    border: none;
    background-color: #fff;
    border-color: #ffffff;
    outline: 0;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    box-shadow: none;
    border-bottom: 1px solid gray;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.9rem;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: none;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    border-bottom: 1px solid #b5b5b5;
    border-radius: 0;
}
.container.fill-height .layout.one-time-payment-wrapper  {
    height: auto!important;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
}
label.onetimeLabel{
 color: rgba(0, 0, 0, 0.54);
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-weight: 400;
    -webkit-transform: scale(.75)!important;
    transform: scale(.75);
    margin-left: -14px;
        display: inline-block;
    margin-bottom: 0;
}
#name_on_card{
    font-size: 16px;
    padding-left: 0;
    padding-top: 0;
}
#postal_on_card{
    font-size: 16px;
    padding-left: 0;
    padding-top: 0;
}
@media only screen and (max-width: 600px) {
    .one-time-payment-wrapper .img-wrap {
        text-align:center;
    }
    .one-time-payment-wrapper .img-wrap img{
        padding: 0 3px;
    }
}



.theme--light .toolbar {
    background-color: #3AB0CE;
    color: rgb(255, 255, 255);
}
.card__text.zip-form {
    padding: 35px;
    width: 100%;
    max-width: 540px;
    margin: 0px auto;
}
.application .theme--light.btn:not(.btn--icon):not(.btn--flat),
.theme--light .btn:not(.btn--icon):not(.btn--flat) {
    background-color: #3ab0ce;
    color: white;
    padding: 0;
}
.StripeElement {
    background-color: white;
    height: 40px;
    padding: 10px 12px;
    border-radius: 0;
    border-bottom: 1px solid #b5b5b5;
    -webkit-box-shadow: 0 1px 3px 0 #e6ebf1;
    box-shadow: none;
    -webkit-transition: box-shadow 150ms ease;
    -webkit-transition: -webkit-box-shadow 150ms ease;
    transition: -webkit-box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease, -webkit-box-shadow 150ms ease;
    width: 100%;
}
#payment-form .card {
    display: block;
    border-radius: 2px;
    min-width: 0;
    position: relative;
    text-decoration: none;
    box-shadow: none;
    border: none;
}
.stripe-card.complete {
  border-color: green;
}
#payment-form .card-images {
    padding: 0 2px;
}

.card-input .card-input-line {
    margin-top: 5px; 
    border-color: rgba(0,0,0,0.42); 
    border-style: solid; 
    border-width: thin 0 0 0; 
    position: relative;
}

.card-input label {
    font-size: 13px; color: rgba(0,0,0,0.54)
}

.card-input .card-input-line:after {
    border-color: currentColor;
    border-style: solid;
    border-width: thin 0 thin 0;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
}

.card-input .card-input-line:after {
    bottom: -0px;
    content: '';
    left: 0;
    position: absolute;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
}

.card-input.focused .card-input-line:after {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
}

.card-connect-input {
  font-size: 15px;
  margin-top: 5px;
  padding: 1px 2px;
  color: rgba(0, 0, 0, 0.87); 
  border-radius: 4px; 
  border: 1px solid;
  border-color: gray;
  line-height: 2.1;
}

.card-connect-input.custom-mr {
  margin-right: 2px;
}

.iframe-wrap.custom-mr {
  margin-right: 2px;
}

.card-connect-input:focus {
  border-color: #00838F;
}
.card-connect-input:focus {
  outline: none;
}
.input-error {
  color: rgb(255,82,82)!important;
  border-color: rgb(255,82,82)!important;
}

@media only screen and (max-width: 420px) {
  .wrap-on-xs {
    flex-wrap: wrap;
  }

  .iframe-wrap.custom-mr {
    margin-right: 0;
  }
}

</style>